export const isCurrentCellChecked = (currentCell, answer) => {
    let findRadioChecked = answer.findIndex(item => item.rowId === currentCell.rowId && item.columnId === currentCell.columnId)
    if (findRadioChecked === -1) {
        return false
    }
    else {
        return true
    }
}